import React from 'react';
import PropTypes from 'prop-types';

/**
 * SelectType
 */
class SelectType extends React.Component {

  // このボックスの表示データを取得
  componentDidMount() {
    this.props.comactions.onMountedType();
    this.handleTypeChange = this.handleTypeChange.bind(this);
  }

  handleTypeChange(e) {
    this.props.actions.changeType(e.target.value);
  }

  render() {
    // 表示データを取得
    let itemList = [];
    // 表示データを生成
    if (this.props.data.pskubun == 1) {
      itemList = this.props.data.itemList.typeList['slotList'];
    } else {
      itemList = this.props.data.itemList.typeList['pachinkoList'];
    }
    // 画面表"すべて"を追加する。
    let displayItemList = [];
    if (itemList.length > 1) {

      const allItem = [{ id: 0, display_name: 'すべて' }];
      displayItemList = allItem;
      let j = 1;
      for (let i = 0; i < itemList.length; i++) {
        displayItemList[j++] = itemList[i];
      }
    } else {
      displayItemList = itemList;
    }

    const type = this.props.data.type;

    const nodes = displayItemList.map((item) => {
      return (
        <option value={item.id} key={item.id}>
          {item.display_name}
        </option>
      );
    });

    return (
      <div>
        <div className="ctrl_form_title controlForm__titleSemiRequire--state_enable controlForm__text--state_enable"><p>タイプ</p></div>
        <label className="select">
          <select name="pw_extraction_02" id="selectType" value={type} className="form-control" onChange={e => this.handleTypeChange(e)}>
            {nodes}
          </select>
        </label>
      </div >
    );
  }
}

SelectType.propTypes = {
  actions: PropTypes.any.isRequired,
  comactions: PropTypes.any.isRequired,
  data: PropTypes.any.isRequired
};

export default SelectType;
